if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product') || document.querySelector('.cc-main-product');
      this.productInfo = this.productSection ? this.productSection.querySelector('.product-info') : document.querySelector('.product-info');
      this.productForm = this.productSection ? this.productSection.querySelector('product-form') : document.querySelector('product-form');
      this.atcButton = this.productSection ? (this.productSection.querySelector('.product-info__add-button') || this.productForm) : this.productForm;
      this.classList.remove('invisible');

      this.bindEvents();
    }

    disconnectedCallback() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
        window.removeEventListener('resize', this.scrollHandler);
      }
    }

    bindEvents() {
      const isMobile = () => (window.innerWidth < 769 || (window.theme && window.theme.mediaMatches && !window.theme.mediaMatches.md));

      const checkScroll = () => {
        const atcTarget = this.atcButton || this.productForm;
        if (!atcTarget) return;

        const isMob = isMobile();
        const atcRect = atcTarget.getBoundingClientRect();
        const infoRect = this.productInfo ? this.productInfo.getBoundingClientRect() : null;

        let shouldShow = false;
        if (isMob) {
          // Mobile: show when scrolled past the main ATC button (bottom of ATC button is above viewport top)
          shouldShow = atcRect.bottom < 60;
        } else {
          // Desktop: show when product info column is scrolled out of view
          shouldShow = infoRect ? (infoRect.bottom < 100) : false;
        }

        // Hide if footer is in viewport or near bottom (avoid overlapping footer)
        const footerEl = document.querySelector('.t-footer-fw-top, .t-footer-compact, .footer-group, footer');
        const footerInView = footerEl ? (footerEl.getBoundingClientRect().top <= window.innerHeight) : false;
        const atBottom = window.scrollY + window.innerHeight + 80 >= document.body.scrollHeight;
        if (footerInView || atBottom) shouldShow = false;

        this.classList.toggle('sticky-atc-panel--out', !shouldShow);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(() => {
          checkScroll();
        }, { threshold: [0, 0.2, 0.5, 0.8, 1.0] });

        if (this.atcButton) observer.observe(this.atcButton);
        if (this.productForm && this.productForm !== this.atcButton) observer.observe(this.productForm);
        if (this.productInfo) observer.observe(this.productInfo);
        const footerEl = document.querySelector('.t-footer-fw-top, .t-footer-compact, .footer-group, footer');
        if (footerEl) observer.observe(footerEl);
      }

      this.scrollHandler = () => {
        checkScroll();
        StickyAtcPanel.handleScroll();
      };

      window.addEventListener('scroll', this.scrollHandler, { passive: true });
      window.addEventListener('resize', this.scrollHandler, { passive: true });
      checkScroll();
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      const footerEl = document.querySelector('.t-footer-fw-top, .t-footer-compact, .footer-group, footer');
      const footerInView = footerEl ? (footerEl.getBoundingClientRect().top <= window.innerHeight) : false;
      document.body.classList.toggle(
        'scrolled-to-bottom',
        footerInView || (window.scrollY + window.innerHeight + 100 > document.body.scrollHeight)
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
